export const searchFunctionality = (array,src)=>{
    let filtered = []
    let props = ["productTitle",'title_1','sub_title_1','content_1','title_2','sub_title_2','content_2','vTitle','vHeader','vContent','fTitle','fContent']
    props.map((ele)=>{
        let filtered_3 = array.filter(pro => {
            return  pro[ele]?.toLowerCase().includes(`${' '}${src}`.toLowerCase())
        })
        filtered =[...filtered,...filtered_3]
        let filtered_1 = array.filter(pro => {
            return  pro[ele]?.toLowerCase().startsWith(src.toLowerCase())
        })
        filtered =[...filtered,...filtered_1]
        let filtered_2 = array.filter(pro => {
            return  pro[ele]?.toLowerCase().split(" ").some(i=>i.startsWith(src.toLowerCase()))
        })
        filtered =[...filtered,...filtered_2]
        const query = src.split(" ") ;
        query.map((word)=>{
            let filtered_4 = array.filter(pro => {
                return  pro[ele]?.toLowerCase().startsWith(word.toLowerCase())
            })
            let filtered_5 = array.filter(pro => {
                return  pro[ele]?.toLowerCase().split(" ").some(i=>i.startsWith(word.toLowerCase()))
            })
            return(
                filtered =[...filtered,...filtered_4,...filtered_5]
            )
        })
        return filtered ;
    })
return filtered ;
}


export const suggestionFunctionality = (array,src)=>{
    let filtered = []
    let props = ["productTitle",'title_1','sub_title_1','content_1','title_2','sub_title_2','content_2','vTitle','vHeader','vContent','fTitle','fContent']
    props.map((ele)=>{
        let filtered_3 = array.filter(pro => {
            return  pro[ele]?.toLowerCase().includes(`${' '}${src}`.toLowerCase())
        })
        filtered_3.map((f)=>{
            return filtered =[...filtered,f[ele]]
        })

        let filtered_1 = array.filter(pro => {
            return  pro[ele]?.toLowerCase().startsWith(src.toLowerCase())
        })
        filtered_1.map((f)=>{
            return filtered =[...filtered,f[ele]]
        })
        
        let filtered_2 = array.filter(pro => {
            return  pro[ele]?.toLowerCase().split(" ").some(i=>i.startsWith(src.toLowerCase()))
        })
        filtered_2.map((f)=>{
            return filtered =[...filtered,f[ele]]
        })
        const query = src.split(" ") ;
        query.map((word)=>{
            let filtered_4 = array.filter(pro => {
                return  pro[ele]?.toLowerCase().startsWith(word.toLowerCase())
            })
            filtered_4.map((f)=>{
                return filtered =[...filtered,f[ele]]
            })
            let filtered_5 = array.filter(pro => {
                return  pro[ele]?.toLowerCase().split(" ").some(i=>i.startsWith(word.toLowerCase()))
            })
            filtered_5.map((f)=>{
                return filtered =[...filtered,f[ele]]
            })
            return filtered
        })
        return filtered ;
    })
return filtered ;
}
